import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M933.974205 1477.39433C811.947215 1477.39433 712.671368 1576.67017 712.671368 1698.69716 712.671368 1820.72415 811.947215 1920 933.974205 1920 1056.00119 1920 1155.27704 1820.72415 1155.27704 1698.69716 1155.27704 1576.67017 1056.00119 1477.39433 933.974205 1477.39433zM1227.94841 0L640 0 783.188111 1298.17148 1084.7603 1298.17148z"
}));

var IconWarningBorderlessLine = /*#__PURE__*/function (_Component) {
  _inherits(IconWarningBorderlessLine, _Component);

  var _super = _createSuper(IconWarningBorderlessLine);

  function IconWarningBorderlessLine() {
    _classCallCheck(this, IconWarningBorderlessLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconWarningBorderlessLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconWarningBorderless",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconWarningBorderlessLine.displayName = "IconWarningBorderlessLine";
  return IconWarningBorderlessLine;
}(Component);

IconWarningBorderlessLine.glyphName = 'warning-borderless';
IconWarningBorderlessLine.variant = 'Line';
IconWarningBorderlessLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconWarningBorderlessLine;
export { IconWarningBorderlessLine };